interface TabPanelProps {
    children?: React.ReactNode;
    index: string;
    value: string;
}

function TabPanel(props: TabPanelProps) {
    const { children, value, index } = props;
    return (
        <div hidden={value !== index}>{value === index && (<>{children}</>)}</div>
    )
}
export default TabPanel;